"use strict";

module.exports = function (
    departments,
    Department,
    Authentication,
    Form,
    reportConfig,
    Integration,
    $state,
    $stateParams,
    BuilderDataService,
    dialog,
    toast,
    $translate,
    ReportConfig,
    $uibModal,
    selectedTab
) {
    this.form = Form;
    this.reportConfig = reportConfig;
    this.departmentTags = [];

    this.department = departments.filter(function (department) {
        return department.id === $state.params.departmentId;
    })[0];
    // console.log('this.department en dashboardBuilderCtrl', this.department)

    this.selectedTab = selectedTab;
    // console.log("selectedTab", selectedTab);

    var _this = this;
    BuilderDataService.setForm(Form);
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");
    this.currentUserIsAdmin = true; // Authentication.isAuthorized("admin"); // to show element level
    _this.form.validate_instances = _this.form.validate_instances || 1;
    _this.form.validate_type = _this.form.validate_type || "distinct";
    
    _this.savedSidebarState = localStorage.getItem('builderSidebarOpen');
    this.openSidebar = _this.savedSidebarState !== null ? _this.savedSidebarState === 'true' : true;
    
    this.toggleSidebar = function () {
        _this.openSidebar = !_this.openSidebar;
        localStorage.setItem('builderSidebarOpen', _this.openSidebar.toString());
    }
    this.addPage = function () {
        this.form.addPage();
    };

    this.movePage = function (index, direction) {
        _this.form.movePage(index, direction);
    };

    this.removePage = function (index) {
        dialog
            .confirm({
                title: $translate.instant(
                    "DASHBOARD.DASH_BUILDER.DIAG_DEL_PAGE.TITLE"
                ),
                body: $translate.instant(
                    "DASHBOARD.DASH_BUILDER.DIAG_DEL_PAGE.BODY"
                ),
                accept: $translate.instant(
                    "DASHBOARD.DASH_BUILDER.DIAG_DEL_PAGE.ACCEPT"
                ),
                cancel: $translate.instant("DASHBOARD.CANCEL"),
                size: "sm",
            })
            .then(function () {
                _this.form.removePage(index);
            });
    };

    this.removeElement = function (id) {
        let bodyInfo = $translate.instant(
            "DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.BODY"
        );
        if (_this.form.items && _this.form.items.length) {
            bodyInfo = $translate.instant(
                "DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.BODYWITHDATA"
            );
        }
        dialog
            .confirm({
                title: $translate.instant(
                    "DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.TITLE"
                ),
                body: bodyInfo,
                accept: $translate.instant(
                    "DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.ACCEPT"
                ),
                cancel: $translate.instant("DASHBOARD.CANCEL"),
                size: "sm",
            })
            .then(function () {
                _this.form.removeElement(id);
            });
    };

    this.cloneElement = function (id) {
        _this.form.cloneElement(id);
    }

    this.onElementDoubleClick = function (element) {
        _this.form.addElementToEnd(element);
    }

    // _this.setMetadataFromWorkflow = (type, workflow, metadata) => {
    //     if (type == "ptw") {
    //         let _m = metadata.find((m) => m.key == "PTW");
    //         if (_m) _m.value = "1";
    //         else metadata.push({ key: "PTW", value: "1" });
    //         if (workflow.geo) {
    //             _m = metadata.find((m) => m.key == "PTW_GEO");
    //             if (_m) _m.value = workflow.geo;
    //             else metadata.push({ key: "PTW_GEO", value: workflow.geo });
    //         }
    //         if (workflow.reject) {
    //             _m = metadata.find((m) => m.key == "PTW_REJECT");
    //             if (_m) _m.value = workflow.reject;
    //             else
    //                 metadata.push({
    //                     key: "PTW_REJECT",
    //                     value: workflow.reject,
    //                 });
    //         }

    //         if (workflow.steps_approved) {
    //             _m = metadata.find((m) => m.key == "PTW_STEPAPPROVED");
    //             if (_m) _m.value = String(workflow.steps_approved);
    //             else
    //                 metadata.push({
    //                     key: "PTW_STEPAPPROVED",
    //                     value: String(workflow.steps_approved),
    //                 });
    //         }
    //         if (workflow.allowChange) {
    //             _m = metadata.find((m) => m.key == "PTW_ALLOWCHANGE");
    //             if (_m) _m.value = workflow.allowChange.join(",");
    //             else
    //                 metadata.push({
    //                     key: "PTW_ALLOWCHANGE",
    //                     value: workflow.allowChange.join(","),
    //                 });
    //         }
    //         if (workflow.steps) {
    //             _m = metadata.find((m) => m.key == "PTW_STEPS");
    //             if (_m) _m.value = workflow.steps.length;
    //             else
    //                 metadata.push({
    //                     key: "PTW_STEPS",
    //                     value: workflow.steps.length,
    //                 });
    //             let members = [];
    //             let checks = [];
    //             for (let i = 0; i < workflow.steps.length; i++) {
    //                 members.push(workflow.steps[i].member);
    //                 checks.push(workflow.steps[i].checkStepON);
    //             }
    //             _m = metadata.find((m) => m.key == "PTW_MEMBERS");
    //             if (_m) _m.value = members.join(",");
    //             else
    //                 metadata.push({
    //                     key: "PTW_MEMBERS",
    //                     value: members.join(","),
    //                 });
    //             _m = metadata.find((m) => m.key == "PTW_CHECKS");
    //             if (_m) _m.value = checks.join(",");
    //             else
    //                 metadata.push({
    //                     key: "PTW_CHECKS",
    //                     value: checks.join(","),
    //                 });
    //         }
    //     }
    // };

    this.save = function (close, expJSON) {
        // console.log('_this.reportConfig', _this.reportConfig);
        // console.log('_this.departmentReportConfig', _this.departmentReportConfig)
        if (!this.form.name) {
            // || !_this.form.description
            return;
        }

        for (var i = 0; i < _this.form.pages.length; i++) {
            if (!_this.form.pages[i].fields.length) {
                toast.success(
                    $translate.instant(
                        "DASHBOARD.DASH_BUILDER.PAGE_WITHOUT_ELEMENTS"
                    )
                );
                return;
            }
        }
        let _items = JSON.parse(JSON.stringify(_this.form.items || []));
        _this.form.items = null;
        _this.loading = true;

        if (_this.form.type && _this.form.workflow) {
            _this.form.metadata = _this.form.metadata || [];
            // _this.setMetadataFromWorkflow(
            //     _this.form.type,
            //     _this.form.workflow,
            //     _this.form.metadata
            // ); //Esto para compatibilidad con la version prototipo
        } else {
            _this.form.type = null;
        }

        // console.log('$state.params', $state.params);

        delete $state.params.selectedTab;

        this.form
            .save($state.params.departmentId)
            .then(function (instance) {
                // console.log('_this.reportConfig', _this.reportConfig);

                // console.log('$state.params', $state.params);

                let reportConfigPromise = Promise.resolve();

                if ($state.params.copy == "true" && $state.params.update == "new") {
                    //Copio el reporte al id
                    reportConfigPromise = ReportConfig.find({
                        filter: { where: { formId: $state.params.oldFormId } },
                    }).$promise.then(function (reportConfig) {
                        if (reportConfig.length > 0) {
                            reportConfig = reportConfig[0];
                            reportConfig.id = undefined;
                            reportConfig.formId = instance.id;
                            
                            return ReportConfig.upsert(reportConfig).$promise.then((rptCfg) => {
                                _this.reportConfig = rptCfg;
                                $state.params.update = "newSaved";
                            });
                        }
                    });
                } 
                // Si es nuevo, se utiliza la plantilla de reportConfig del departmento (si existe), si no es editar. 
                else if (($state.params.formId == 'new' && _this.reportConfig) || (_this.form.id != undefined && _this.form.id != null && _this.reportConfig)) {

                    // _this.reportConfig could be an Array or an object, we need the object. 
                    let reportConfig = _this.reportConfig &&
                        (Array.isArray(_this.reportConfig) ? (_this.reportConfig.length > 0 ? _this.reportConfig[0] : null) :
                            (typeof _this.reportConfig === 'object' ? _this.reportConfig : null));

                    if ($state.params.formId == 'new') {
                        reportConfig.formId = instance.id;
                    } else {
                        reportConfig.formId = _this.form.id;
                    }
                    
                    reportConfigPromise = ReportConfig.upsert(reportConfig).$promise.then(
                        function (rpt) {
                            reportConfig.id = rpt.id;
                            _this.reportConfig = reportConfig;
                            toast.success(
                                $translate.instant(
                                    "DASHBOARD.DASH_FORM.REPORT.LBL_CONFIG_OK"
                                )
                            );

                            if ($state.params.formId == 'new') { 
                                return $state.go("dashboard.departments.department.forms.form.builder", {formId: instance.id}, { reload: true });
                            }
                        }
                    );
                }

                return reportConfigPromise.then(function () {
                    if (close) {
                        if ($state.params.formId == 'new') {
                            return $state
                                .go("dashboard.departments.department.forms", {}, { reload: true })
                                .then(function () {
                                    $state.go(
                                        "dashboard.departments.department.forms.form.teams",
                                        {
                                            formId: instance.id,
                                        }
                                    );
                                }
                                );
                        } else {
                            return $state.go("dashboard.departments.department.forms", {}, { reload: true })
                        }
                    }
                    return;
                }).then(function () {
                    if (!close) {
                        toast.success(
                            $translate.instant("DASHBOARD.DASH_BUILDER.SAVE_OK_TOAST")
                        );
                    }
                    _this.form.items = _items;
                    _this.form.id = instance.id;
                    _this.form.departmentId = $state.params.departmentId;
                    //Authentication.loadDepartments();
                    _this.loading = false;

                    // EXPORTAR
                    if (expJSON) {
                        _this.exportJSON(_this.form, instance);
                    }
                })
            })
            .catch(function (error) {
                _this.loading = false;
                console.log(error);
            });
    };

    this.exportDialog = function () {
        // console.log('_this.form', _this.form);
        dialog
            .confirm({
                title: $translate.instant("DASHBOARD.DASH_FORM.DIAG_EXPORT.TITLE"),
                body: $translate.instant("DASHBOARD.DASH_FORM.DIAG_EXPORT.BODY"),
                accept: $translate.instant("DASHBOARD.DASH_FORM.DIAG_EXPORT.ACCEPT"),
                cancel: $translate.instant("DASHBOARD.CANCEL"),
                size: "sm",
            })
            .then(function () {
                _this.save(false, true);
            });
    }

    this.exportJSON = (form, instance) => {
        let form1 = JSON.parse(JSON.stringify(form));
        let reportConfig = _this.reportConfig &&
            (Array.isArray(_this.reportConfig) ? (_this.reportConfig.length > 0 ? _this.reportConfig[0] : null) :
                (typeof _this.reportConfig === 'object' ? _this.reportConfig : null));

        let integrationsSet = new Set();
        let integrationsArray = [];
        let integrationIds = new Set();
        let stopProcessing = false;

        const collectIntegrationIds = (field) => {
            if (field.integration && field.integration.id) {
                integrationIds.add(field.integration.id);
            }

            if (field.nodes && Array.isArray(field.nodes)) {
                field.nodes.forEach(collectIntegrationIds);
            }
        };

        // // Form element's Integrations
        // form1.pages.forEach(function (page) {
        //     page.fields.forEach(collectIntegrationIds);
        // });

        // Form element's and validate element's Integrations
        [form1.pages, form1.validate_pages].forEach(pages => {
            pages?.forEach(page => {
                if (Array.isArray(page.fields)) {
                    page.fields.forEach(collectIntegrationIds);
                }
            });
        });


        if (integrationIds.size === 0) {
            return processAndDownloadFile();
        }

        let integrationPromises = Integration.find({
            filter: {
                where: {
                    id: { inq: Array.from(integrationIds) }
                }
            }
        }).$promise
            .then(function (integrations) {
                integrations.forEach(integration => {
                    let integrationString = JSON.stringify(integration);
                    if (!integrationsSet.has(integrationString)) {
                        integrationsSet.add(integrationString);
                        integrationsArray.push(integration);
                    }
                });
            })
            .catch(function (error) {
                console.error('Error al buscar integraciones:', error);
                const errorMessage = error.message || error?.data?.error?.message;
                stopProcessing = true;
                return Promise.reject(`Error al buscar integraciones: ${errorMessage}`);
            });

        return integrationPromises
            .then(() => {
                if (stopProcessing) return;

                return processAndDownloadFile();
            })
            .catch(error => {
                console.error('Error en la exportación JSON:', error);
                toast.error(`Error: ${error}`);
            });

        function processAndDownloadFile() {
            return new Promise((resolve, reject) => {
                let file = {
                    form: JSON.parse(JSON.stringify(form1))
                };
                if (integrationsArray.length > 0) {
                    file.integrations = JSON.parse(JSON.stringify(integrationsArray));
                }
                if (reportConfig) {
                    file.reportConfig = JSON.parse(JSON.stringify(reportConfig));
                }
                delete file.form.id;
                delete file.form.departmentId;
                delete file.form.tenantId;
                delete file.form.items;
                if (file.form.subscribed == null || file.form.subscribed == undefined) { file.form.subscribed = instance.subscribed; }
                if (file.form._createdAt == null || file.form._createdAt == undefined) { file.form._createdAt = instance._createdAt; }

                let file2 = JSON.stringify(file, null, 2);

                var blob = new Blob([file2], { type: 'application/json' });
                var url = URL.createObjectURL(blob);

                var a = document.createElement('a');
                a.href = url;
                a.download = form.name.concat('.json');
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);

                resolve();
            }).catch(error => {
                console.error('Error en la exportación JSON:', error);
                toast.error(`Error: ${error}`);
            });
        }
    }

    this.cancel = function () {
        return $state.go("dashboard.departments.department.forms", {}, { reload: true })
    };

    // Teams Modal
    this.teamsDialog = () => {
        $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-builder/teamsModal.html',
            controller: ["$uibModalInstance", "teams", "form", "Department", "$state", "toast", "$translate",
            function ($uibModalInstance, teams, form, Department, $state, toast, $translate) 
            {
                var _this = this;
                
                this.mapTeamsWithStatus = (teamsList) => {
                    return teamsList.map(function(team) {
                        var isSub = team.subscribedTo.filter(function(teamForm) {
                            return teamForm.id === $state.params.formId;
                        });

                        if (isSub.length) {
                            team.status = true;
                        } else {
                            team.status = false;
                        }
                        return team;
                    });
                };

                this.form = form

                _this.teams = _this.mapTeamsWithStatus(teams);

                this.subscriptionHandler = function(itemId, status) {
                    if (status) {
                        Department.addTeam({
                            departmentId: $state.params.departmentId,
                            formId: $state.params.formId,
                            teamId: itemId
                        }, {})
                        .$promise
                        .then(function () {
                            toast.success($translate.instant('DASHBOARD.DASH_FORM.TEAMS.ADD_TEAM'));
                        })
                        .catch(function(error) {
                            toast.error($translate.instant('DASHBOARD.DASH_FORM.TEAMS.ADD_TEAM_ERR'));
                            console.log(error);
                        });
                    } else {
                        Department.removeTeam({
                            departmentId: $state.params.departmentId,
                            formId: $state.params.formId,
                            teamId: itemId
                        }, {})
                        .$promise
                        .then(function() {
                            toast.success($translate.instant('DASHBOARD.DASH_FORM.TEAMS.REMOVE_TEAM'));
                            return;

                        })
                        .catch(function(error) {
                            toast.error($translate.instant('DASHBOARD.DASH_FORM.TEAMS.REMOVE_TEAM_ERR'));
                            console.log(error);
                        });
                    }
                };

                this.reloadTeams = function () {
                    const teamsFilter = {
                        include: [{
                            relation: 'subscribedTo',
                            scope: {
                                fields: 'id'
                            }
                        }, {
                            relation: 'members',
                            scope: {
                                fields: 'id'
                            }
                        }]
                    };

                    Department.teams({
                        id: $state.params.departmentId,
                        filter: teamsFilter
                    }).$promise.then(function (updatedTeams) {
                        _this.teams = _this.mapTeamsWithStatus(updatedTeams);
                    }).catch(function (error) {
                        toast.error($translate.instant('DASHBOARD.DASH_FORM.TEAMS.NO_INFO'));
                        console.log(error);
                    });
                };

                this.close = function () {
                    $uibModalInstance.close();
                };
            }],
            controllerAs: "ctrl",
            size: "xlg",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                teams: function () {
                    return Department.teams({
                        id: $stateParams.departmentId,
                        filter: {
                            include: [{
                                relation: 'subscribedTo',
                                scope: {
                                    fields: 'id'
                                }
                            }, {
                                relation: 'members',
                                scope: {
                                    fields: 'id'
                                }
                            }]
                        }
                    }).$promise.then(function (teams) {
                        return teams;
                    });
                },
                form: function () {
                    return _this.form;
                }
            }
        }).result.then((result) => {
        }, function() { //dismiss
        });
    }

    this.openFormConfig = function (activeTab) {
        if (_this.form.id == undefined) {
            toast.success(
                $translate.instant("DASHBOARD.DASH_BUILDER.MUST_SAVE")
            );
            return;
        }
        var options = {
            animation: true,
            controller: require("./formConfig/formConfigCtrl"),
            templateUrl: "dashboard-builder/formConfig/formConfigModal.html",
            controllerAs: "ctrl",
            size: "xlg",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                form: function () {
                    return _this.form;
                },
                activeTab: function () {
                    return activeTab;
                },
                reportConfig: function () {
                    // console.log('_this.reportConfig modal', _this.reportConfig)
                    return _this.reportConfig;
                },
                ownersAndSupervisors: function () {
                    return _this.department.owners;
                },
                departmentTags: function() {
                    return _this.departmentTags;
                },
                departmentReportConfig: function() {
                    return _this.department.reportConfig;
                },
            },
        };

        $uibModal.open(options).result.then((response) => {
            _this.reportConfig = response.reportConfig;
            _this.form.validate_users = [].concat(response.ownersListToAdd);

            _this.form.validate_defined = response.validate_defined;
            if (_this.form.validate_type === "instance-defined") {
                _this.form.validate_defined.map((instance, $index) => {
                    instance.validate_users = [].concat(response.ownersListToAddInstance[$index]);
                })
            };
            
            if (Array.isArray(response.metadata)) {
                response.metadata = response.metadata.reduce((lst, item) => {
                    if (item.value != undefined && item.value != "")
                        lst.push(item);
                    return lst;
                }, []);
                if (response.metadata.length == 0) _this.form.metadata = null;
                else _this.form.metadata = [].concat(response.metadata);
            } else delete _this.form.metadata;
        });
    };

    this.treeOptions = {
        accept: function A(sourceNodeScope, destNodesScope) {

            var depth = destNodesScope.depth();
            var sourceType = sourceNodeScope.$modelValue.type;

            //Max depth is page>element>subelement>subelement2 (there is subelement3 level)
            //At depth 0 can only drop pages
            if (depth == 0) {
                return sourceType === "page";
            }
            //At depth 1 can drop anything but pages (this is inside a page)
            else if (depth == 1) {
                return sourceType !== "page";
            }
            //At depth 2 it gets more complex
            else if (depth >= 2) {
                var destType = destNodesScope.$parent.ctrl.element.type;
                switch (sourceType) {
                    //Can't drop pages
                    case "page":
                        return false;
                    //we can drop groups or simplelists into anything but a group or list. (Isn't this the same as only inside page? Can we actually drop groups or simplelists at this depth?)
                    case "group":
                        return depth <= 3;
                    case "simplelist":
                        return destType == "group" && depth <= 3;
                    //These can be droped inside group AND simplelist
                    case "select":
                    case "text":
                    case "sendemail":
                    case "number":
                    case "date":
                    case "time":
                    case "qr":
                    case "geo":
                    case "formula":
                    case "duration":
                    case "checkbox":
                    case "sign":
                    case "multiple":
                    case "video":
                    case "photo":
                        return (
                            destType === "group" || destType === "simplelist"
                        );
                    //All other elements can be droped inside group only
                    default:
                        return (
                            destType === "group" || destType === "simplelist"
                        );
                }
            }
            return false;
        },
    };

    this.elementsOptions = {
        dropped: function (event) {
            // console.log('dropped', event);
            event.source.cloneModel.id = Math.random().toString(36).substr(2, 9);
        },
    };
    this.elementsList = require("./dashboardBuilderElements")($translate);

    // To open actions modal
    if (_this.selectedTab && _this.selectedTab === '0') {
        _this.openFormConfig(0)
    }

    // NEW FORMS: REPORTCONFIG UNDEFINED
    if (!_this.form.id) {
        // console.log('!_this.form.id')
        if (Array.isArray(_this.reportConfig) && _this.reportConfig.length === 0) {
            // console.log('if (Array.isArray(_this.reportConfig) && _this.reportConfig.length === 0) {')
            // _this.reportConfig = undefined;
            // If department has a report config template, it will be asigned to the new form.
            _this.reportConfig = _this.department.reportConfig || undefined;
        }
    }

    this.openQRModal = () => {
        $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-builder/qrModal.html',
            controller: ["$uibModalInstance", "$sce", "qrCode", "$timeout", function ($uibModalInstance, $sce, qrCode, $timeout) {
                var _this = this;

                _this.qrCodeCanvas = qrCode;
                $timeout(function() {
                    let container = document.getElementById('qrCodeContainer');
                    if (container && _this.qrCodeCanvas) {
                        container.appendChild(_this.qrCodeCanvas);
                        _this.qrCodeCanvas.style.display = 'block';
                    }
                }, 100);

                this.close = function () {
                    $uibModalInstance.close();
                };
            }],
            controllerAs: "ctrl",
            size: "md",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                qrCode: function() {
                    let tempDiv = document.createElement('div');
                    new QRCode(tempDiv, {
                        text: `field4://dept/${this.form.departmentId}/form/${this.form.id}`,
                        width: 256,
                        height: 256,
                        colorDark: "#000000",
                        colorLight: "#ffffff",
                        correctLevel: QRCode.CorrectLevel.H
                    });
                
                    let canvas = tempDiv.querySelector('canvas');
                    return canvas;
                }.bind(this)
            }
        }).result.then((result) => {
        }, function() { //dismiss
        });
    }

    this.openIntegrationsList = function () {
        const toId = (value) => {
            if (value == null || value === "") {
                return "";
            }
            if (typeof value === "string" || typeof value === "number") {
                return String(value);
            }
            if (typeof value === "object") {
                if (value.$oid) {
                    return String(value.$oid);
                }
                if (typeof value.toString === "function") {
                    const asString = value.toString();
                    if (asString && asString !== "[object Object]") {
                        return asString;
                    }
                }
            }
            return "";
        };

        const collectArchivedFieldIds = (form) => {
            const archivedFieldIds = {};
            const walk = (fields) => {
                (fields || []).forEach((field) => {
                    if (!field) {
                        return;
                    }
                    if (field.isArchived && field.id != null) {
                        archivedFieldIds[toId(field.id)] = true;
                    }
                    if (Array.isArray(field.nodes) && field.nodes.length) {
                        walk(field.nodes);
                    }
                });
            };
            ((form && form.pages) || []).forEach((page) => walk(page && page.fields));
            ((form && form.validate_pages) || []).forEach((page) => walk(page && page.fields));
            return archivedFieldIds;
        };

        const mapIntegrations = (result) => {
            const pages = [];
            const validatePages = [];
            const groups = [];
            const archivedFieldIds = collectArchivedFieldIds(_this.form);

            (Array.isArray(result) ? result : []).forEach((item) => {
                if (!item) {
                    return;
                }
                if (Array.isArray(item.fields)) {
                    groups.push(item);
                    return;
                }
                const integrationId = toId(item.integrationId || item.id);
                let group = groups.find((current) => toId(current.id) === integrationId);
                if (!group) {
                    group = {
                        id: integrationId,
                        name: item.integrationName || item.name,
                        type: item.integrationType || item.type,
                        fields: [],
                    };
                    groups.push(group);
                }
                if (item.fieldId || item.fieldName) {
                    group.fields.push(item);
                }
            });

            groups.forEach((integration) => {
                (integration.fields || []).forEach((field) => {
                    if (archivedFieldIds[toId(field.fieldId)]) {
                        return;
                    }
                    const item = {
                        integration: {
                            id: toId(integration.id),
                            name: integration.name || "¿?",
                            type: integration.type || "¿?",
                            integrationDeleted: field.integrationDeleted === true || integration.integrationDeleted === true,
                        },
                        fieldId: field.fieldId,
                        label: field.fieldName || field.fieldId,
                        type: field.fieldType,
                    };
                    if (field.section === "validate_pages") {
                        validatePages.push(item);
                    } else {
                        pages.push(item);
                    }
                });
            });

            return { pages: pages, validatePages: validatePages };
        };

        var options = {
            animation: true,
            controller: [
                "$uibModalInstance",
                "Form",
                "form",
                function ($uibModalInstance, Form, form) {
                    var _this = this;
                    this.form = form;
                    this.loading = true;
                    this.error = false;
                    this.empty = false;
                    this.lstIntegrationsUsing = [];
                    this.lstValidateIntegrationsUsing = [];

                    this.close = function () {
                        $uibModalInstance.close();
                    };

                    if (!form || !form.id) {
                        this.loading = false;
                        this.empty = true;
                        return;
                    }

                    if (typeof Form.findIntegrations !== "function") {
                        this.loading = false;
                        this.error = true;
                        return;
                    }

                    Form.findIntegrations({ formId: form.id })
                        .$promise
                        .then(function (integrations) {
                            const usages = mapIntegrations(integrations);
                            _this.lstIntegrationsUsing = usages.pages;
                            _this.lstValidateIntegrationsUsing = usages.validatePages;
                            _this.empty = usages.pages.length === 0 && usages.validatePages.length === 0;
                            _this.loading = false;
                        })
                        .catch(function (err) {
                            console.error(err);
                            _this.error = true;
                            _this.loading = false;
                        });
                },
            ],
            templateUrl: "dashboard-builder/integrationsList/integrationsListDirectiveModal.html",
            controllerAs: "ctrl",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                form: function () {
                    return _this.form;
                },
            },
        };

        $uibModal.open(options).result.then(
            function (result) {},
            function () {}
        );
    }

    this.openAiSchema = function () {
        const walkFields = (fields, depth, out) => {
            (fields || []).forEach((field) => {
                if (!field) {
                    return;
                }
                out.push({
                    id: field.id,
                    label: (field.name || field.label || "").trim() || field.id,
                    field: field,
                    depth: depth,
                });
                if (Array.isArray(field.nodes) && field.nodes.length) {
                    walkFields(field.nodes, depth + 1, out);
                }
            });
        };

        const buildPages = (pages, titleKey) => {
            return (pages || []).map((page, index) => {
                const nodes = [];
                walkFields(page && page.fields, 0, nodes);
                return {
                    title: $translate.instant(titleKey, { n: index + 1 }),
                    nodes: nodes,
                    empty: nodes.length === 0,
                };
            });
        };

        var options = {
            animation: true,
            controller: [
                "$uibModalInstance",
                "$uibModal",
                "form",
                "schemaPages",
                "validatorPages",
                function ($uibModalInstance, $uibModal, form, schemaPages, validatorPages) {
                    var _this = this;
                    this.form = form;
                    this.pages = schemaPages;
                    this.validatorPages = validatorPages;
                    const saved = form.aiAssistant || {};
                    this.aiEnabled = !!(saved.enabled && saved.termsAccepted);
                    this.assistantOn = this.aiEnabled;

                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };

                    const setEnabled = (enabled) => {
                        form.aiAssistant = {
                            enabled: !!enabled,
                            termsAccepted: !!enabled,
                            termsAcceptedAt: enabled ? new Date().toISOString() : null,
                        };
                        _this.aiEnabled = !!enabled;
                        _this.assistantOn = !!enabled;
                    };

                    this.onToggleAi = function () {
                        if (!_this.aiEnabled) {
                            setEnabled(false);
                            return;
                        }

                        $uibModal.open({
                            animation: true,
                            controller: [
                                "$uibModalInstance",
                                "$timeout",
                                "$scope",
                                function ($uibModalInstance, $timeout, $scope) {
                                    var terms = this;
                                    this.canAccept = false;

                                    this.accept = function () {
                                        if (!terms.canAccept) {
                                            return;
                                        }
                                        $uibModalInstance.close(true);
                                    };

                                    this.cancel = function () {
                                        $uibModalInstance.dismiss();
                                    };

                                    var bindScroll = function (tries) {
                                        var el = document.querySelector(".ai-terms-scroll");
                                        if (!el || !el.clientHeight) {
                                            if (tries < 10) {
                                                $timeout(function () {
                                                    bindScroll(tries + 1);
                                                }, 50);
                                            }
                                            return;
                                        }
                                        var check = function () {
                                            if (!el.clientHeight) {
                                                return;
                                            }
                                            var reached = el.scrollTop + el.clientHeight >= el.scrollHeight - 16;
                                            if (reached && !terms.canAccept) {
                                                terms.canAccept = true;
                                                $scope.$applyAsync();
                                            }
                                        };
                                        el.addEventListener("scroll", check);
                                        check();
                                    };
                                    $timeout(function () {
                                        bindScroll(0);
                                    });
                                },
                            ],
                            templateUrl: "dashboard-builder/aiSchema/aiTermsModal.html",
                            controllerAs: "ctrl",
                            size: "lg",
                            windowClass: "dialog",
                            backdrop: "static",
                            keyboard: false,
                        }).result.then(function () {
                            setEnabled(true);
                        }, function () {
                            setEnabled(false);
                        });
                    };
                },
            ],
            templateUrl: "dashboard-builder/aiSchema/aiSchemaModal.html",
            controllerAs: "ctrl",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                form: function () {
                    return _this.form;
                },
                schemaPages: function () {
                    return buildPages(_this.form && _this.form.pages, "DASHBOARD.DASH_BUILDER.AI_SCHEMA.PAGE");
                },
                validatorPages: function () {
                    const pages = (_this.form && _this.form.validate_pages) || [];
                    return buildPages(pages, "DASHBOARD.DASH_BUILDER.AI_SCHEMA.VALIDATOR_PAGE")
                        .filter((page) => !page.empty);
                },
            },
        };

        $uibModal.open(options).result.then(
            function () {},
            function () {}
        );
    }

    this.getDepartmentTags = function () {
        Department.tags({
            id: this.department.id,
        })
        .$promise.then(function (data) {
            const cleanData = JSON.parse(JSON.stringify(data));
            _this.departmentTags = cleanData?.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });
        })
        .catch(function (error) {
            console.log(error);
        });
    }
    this.getDepartmentTags();

    // console.log('dashboardBuilder reportConfig', reportConfig);
    // console.log('dashboardBuilder _this.reportConfig', _this.reportConfig);
    // console.log('dashboardBuilder _this.department', _this.department);
    // console.log('dashboardBuilder _this.form', _this.form);
};
